module.exports = "https://img.zhijierongxing.com/saas/img/logo.76c77ffc.png";